export default "__VITE_ASSET__1d46ad26__"